export default __webpack_public_path__ + "static/media/oh.e56c7e52.mp3";